/**
 * Created by mac on 12/23/20
 */

const MineableView = cc.Node.extend({
    ctor: function (mine, unitView) {
        this._super();

        this.mine = mine;
        this.unitView = unitView;
        this.visible = false;
       
        this.createProgress();
        this.restoreState();
    },

    restoreState: function (animated) {
        const worker = Map2d.currentMap.workers.findAssigned(this.mine.unit);

        if (this.progress) {
            if (cleverapps.gameModes.hideGuideAndProgress || InfoView.IsDisplayedFor(this.mine.unit) || this.mine.mined === 0 || worker) {
                this.hideProgress(animated);
            } else {
                this.showProgress(animated);
            }

            this.updateProgress(animated);
        }

        if (this.mine.isFree() && !cleverapps.environment.isEditorScene() && !cleverapps.config.demoMode) {
            this.createFreePrize(animated);
        } else {
            this.removeFreePrize(animated);
        }

        this.updateMissionPoints(animated);

        if (worker) {
            worker.onUpdateState();
        }
    },

    createProgress: function () {
        const abTestStyles = cleverapps.styles.MineableViewAbTest;
        const styles = abTestStyles ? cleverapps.styles.MineableViewAbTest.progress : cleverapps.styles.MineableView.progress;

        if (this.mine.countStages() < 2) {
            return;
        }

        this.progress = new ScaledProgressBar({
            type: styles.type
        });
        this.progress.hidden = false;
        this.unitView.addChild(this.progress);
        this.progress.setAnchorPoint(0.5, 0.5);
        this.progress.setLength(styles.width);

        if (["adventure", "adventureny"].includes(cleverapps.skins.getSlot("skinName"))) {
            this.progress.setAlignment(this.unitView.width / 2, 0.9 * this.unitView.height);
        } else {
            this.progress.setAlignment(styles);
            const fog = Map2d.currentMap.getFog(this.unitView.unit.x - 1, this.unitView.unit.y + 1);
            if (fog && styles.upY) {
                this.progress.setAlignment(styles.x, styles.upY);
            }
        }
    },

    updateProgress: function (animated) {
        const total = this.mine.countStages();
        this.progress.setGoal(total);
        const current = total - this.mine.mined;
        this.progress.setPercentage(current, {
            animated
        });
    },

    showProgress: function (animated) {
        if (!this.progress.hidden) {
            return;
        }
        this.progress.hidden = false;
        this.progress.stopAllActions();

        if (!animated) {
            this.progress.setVisible(true);
            return;
        }

        const styles = cleverapps.styles.MineableView;

        this.progress.setPositionY(this.progress.y + styles.progress.moveByY);
        this.progress.setScale(0.5);
        this.progress.setVisible(true);

        this.progress.runAction(new cc.Spawn(
            new cc.MoveBy(0.1, 0, -styles.progress.moveByY),
            new cc.ScaleTo(0.1, 1)
        ));
    },

    hideProgress: function () {
        if (this.progress.hidden) {
            return;
        }
        this.progress.hidden = true;
        this.progress.stopAllActions();
        this.progress.setVisible(false);
    },

    createFreePrize: function (animated) {
        const options = {
            onClick: this.mine.unit.handleClick.bind(this.mine.unit),
            unit: this.mine.unit
        };
        const prizeView = cleverapps.skins.getSlot("hasGrabInfoView") ? new GrabInfoView(options) : new PrizeView({ }, options);
        prizeView.setAlignment(this.unitView.width / 2, this.unitView.height);

        if (animated) {
            this.unitView.animateAppearAdditionalView("free", prizeView);
        } else {
            this.unitView.createAdditionalView("free", prizeView);
        }
    },

    handlePrizes: function () {
        if (this.unitView.sprite instanceof cleverapps.Spine && this.unitView.sprite.hasAnimation("spawn")) {
            this.unitView.sprite.setAnimation(0, "spawn", false);
            this.unitView.sprite.setCompleteListenerOnce(() => {
                UnitView.applyDefaultAnimation(this.unitView.sprite, this.mine.unit);
            });
            this.unitView.sprite.setSafeToRemove();
        }
    },

    removeFreePrize: function (animated) {
        this.unitView.removeAdditionalView("free", !animated);
    },

    updateMissionPoints: function () {
        const missionsRewards = this.mine.listActiveMissionRewards();

        const shownTypes = Object.keys(this.pointsIcons || {});
        const activeTypes = missionsRewards.map((missionReward) => missionReward.missionType);

        const wasRemoved = cleverapps.substract(shownTypes, activeTypes).length > 0;
        const wasAdded = cleverapps.substract(activeTypes, shownTypes).length > 0;
        if (wasRemoved || wasAdded) {
            this.hideMissionPoints();
            this.showMissionPoints();
        }
    },

    hideMissionPoints: function () {
        this.pointsGeneration = (this.pointsGeneration || 0) + 1;

        if (this.pointsLayout) {
            this.pointsLayout.stopAllActions();
            this.pointsLayout.runAction(new cc.Sequence(
                StandartAnimations.disappear(this.pointsLayout),
                new cc.RemoveSelf()
            ));
            delete this.pointsLayout;
            delete this.pointsIcons;
            delete this.visiblePointType;
        }
    },

    showMissionPoints: function () {
        const styles = cleverapps.styles.MineableView.points;

        this.pointsIcons = {};

        this.mine.listActiveMissionRewards().forEach((missionReward) => {
            let animation;

            switch (missionReward.missionType) {
                case Mission.TYPE_ISLAND_DECORATION: {
                    const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_ISLAND_DECORATION);
                    const period = mission && mission.logic.period;
                    if (period) {
                        animation = bundles.merge.jsons[`island_decoration_point_${period}`];
                    }
                    break;
                }
                case Mission.TYPE_TREASURE_SEARCH:
                    animation = bundles.merge.jsons.treasure_search_point;
                    break;
                case Mission.TYPE_SPACE_RACE:
                    animation = bundles.merge.jsons.space_race_point;
                    break;
                case Mission.TYPE_HUNGRY_GAMES:
                    animation = bundles.merge.jsons.hungry_games_point;
                    break;
            }

            this.pointsIcons[missionReward.missionType] = new cleverapps.Spine(animation);
        });

        this.pointsGeneration = (this.pointsGeneration || 0) + 1;

        this.pointsLayout = new cc.Node();
        this.pointsLayout.setAnchorPoint(0.5, 0.5);
        this.pointsLayout.setContentSize2(styles.icon.width, styles.icon.height);

        Object.values(this.pointsIcons).forEach((icon) => {
            icon.setVisible(false);
            icon.setPosition(this.pointsLayout.width / 2, this.pointsLayout.height / 2);
            this.pointsLayout.addChild(icon);
        });

        this.pointsLayout.setAlignment(styles);
        this.unitView.addChild(this.pointsLayout);

        this.showMissionPoint(Object.keys(this.pointsIcons)[0]);
    },

    showMissionPoint: function (missionType) {
        const icon = this.pointsIcons && this.pointsIcons[missionType];
        if (!icon) {
            return;
        }

        this.visiblePointType = missionType;
        icon.setVisible(true);

        if (Object.keys(this.pointsIcons).length < 2) {
            icon.setIdleSet({
                idle: 200,
                smile: 20
            });
            return;
        }

        const generation = this.pointsGeneration;
        icon.setAnimation(0, "idle", false);
        icon.setCompleteListenerOnce(() => {
            if (generation === this.pointsGeneration) {
                this.rotateMissionPoints(missionType);
            }
        });
        icon.setSafeToRemove();
    },

    rotateMissionPoints: function (missionType) {
        const styles = cleverapps.styles.MineableView.points.carousel;

        const types = Object.keys(this.pointsIcons || {});
        if (!this.pointsLayout || types.length === 0) {
            return;
        }

        const nextType = types[(types.indexOf(missionType) + 1) % types.length];
        if (nextType === missionType) {
            this.showMissionPoint(missionType);
            return;
        }

        const center = cc.p(this.pointsLayout.width / 2, this.pointsLayout.height / 2);

        const current = this.pointsIcons[missionType];
        if (current) {
            current.setLocalZOrder(0);
            current.runAction(new cc.Sequence(
                new cc.Spawn(
                    new cc.BezierTo(styles.duration, [
                        cc.p(center.x + styles.shift, center.y),
                        cc.p(center.x + styles.shift, center.y + styles.backDy),
                        cc.p(center.x, center.y + styles.backDy)
                    ]),
                    new cc.ScaleTo(styles.duration, 0.5),
                    new cc.FadeOut(styles.duration)
                ),
                new cc.Hide(),
                new cc.CallFunc(() => {
                    current.setPosition(center);
                    current.setOpacity(255);
                    current.setScale(1);
                })
            ));
        }

        const next = this.pointsIcons[nextType];
        this.visiblePointType = nextType;
        next.stopAllActions();
        next.setLocalZOrder(1);
        next.setPosition(center.x, center.y + styles.backDy);
        next.setOpacity(0);
        next.setScale(0.5);
        next.setVisible(true);
        next.runAction(new cc.Sequence(
            new cc.Spawn(
                new cc.BezierTo(styles.duration, [
                    cc.p(center.x - styles.shift, center.y + styles.backDy),
                    cc.p(center.x - styles.shift, center.y),
                    cc.p(center.x, center.y)
                ]),
                new cc.ScaleTo(styles.duration, 1),
                new cc.FadeIn(styles.duration)
            ),
            new cc.CallFunc(() => {
                this.showMissionPoint(nextType);
            })
        ));
    },

    giveMissionReward: function (missionType, callback) {
        const icon = this.pointsIcons && this.pointsIcons[missionType];
        if (!icon) {
            callback();
            return;
        }

        delete this.pointsIcons[missionType];

        icon.stopAllActions();
        icon.setVisible(true);
        icon.setOpacity(255);
        icon.setScale(1);
        icon.replaceParentSamePlace(cleverapps.Scenes.GetRunningScene(), {
            keepScale: true
        });

        icon.runAction(new cc.Sequence(
            StandartAnimations.animateCollect(icon, `mission${missionType}`, {
                adjustToTarget: true,
                collectEffect: true,
                effect: "menubar.exp.fly_finish"
            }),
            new cc.RemoveSelf()
        )).setFinalize(callback);

        const types = Object.keys(this.pointsIcons);
        if (types.length === 0) {
            this.hideMissionPoints();
            return;
        }

        if (this.visiblePointType === missionType) {
            this.pointsGeneration = (this.pointsGeneration || 0) + 1;

            const center = cc.p(this.pointsLayout.width / 2, this.pointsLayout.height / 2);
            types.forEach((type) => {
                const rest = this.pointsIcons[type];
                rest.stopAllActions();
                rest.setVisible(false);
                rest.setOpacity(255);
                rest.setScale(1);
                rest.setPosition(center);
            });

            this.showMissionPoint(types[0]);
        }
    }
});

cleverapps.styles.MineableView = {
    progress: {
        type: ScaledProgressBar.Types.blue_small_with_frames,
        moveByY: 15,
        x: { align: "center" },
        y: { align: "bottom", dy: 5 },
        width: 84
    },
    points: {
        x: { align: "center", dx: 54 },
        y: { align: "center", dy: 31 },
        margin: 5,
        icon: {
            width: 60,
            height: 60
        },
        carousel: {
            shift: 25,
            backDy: 15,
            duration: 0.3
        }
    }
};